/**
 * Types of user plans.
 */
export enum PlanType {
    Public = 'PUBLIC',
    Demo = 'DEMO',
    Lite = 'LITE',
    Enterprise = 'ENTERPRISE',
}